import React, { useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonTextarea,
    IonButton,
    IonToast,
} from '@ionic/react';

const Footer: React.FC = () => {

    const [formData, setFormData] = useState({ email: '' });
    const [showToast, setShowToast] = useState(false);

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.detail.value });
    };

    const handleSubmit = async (e: any) => {
        console.log('here')
        e.preventDefault();
        const response = await fetch('https://mamasguidance.com/subscribe.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        });
        const data = await response.json();
        console.log('Server response:', data);
        if (response.ok) {
            setShowToast(true);
            setFormData({ email: '' });
        } else {
            console.error('Server returned error:', data);
        }
    };

    return (
        <>
            <footer className="mg-footer">
                <div className="footer-top">
                    <div className="footer-col">
                        <div className="footer-logo mb-25">
                            <a href="/"><img src="assets/logo-500.png" style={{ height: '200px' }} alt="" /></a>
                        </div>
                        <div className="footer-tittle">
                            <div className="footer-pera">
                                <p><strong>Mamas Guidance</strong> is an innovative platform designed to nurture young minds by providing them with <strong>engaging</strong> and <strong>effective learning experiences</strong>. Our mission is to make education <strong>enjoyable</strong>, <strong>accessible</strong>, and <strong>impactful</strong> for children of all ages.</p>
                            </div>

                            <div className="social-icons">
                                <a href="https://www.facebook.com/profile.php?id=61577840330706" target='_blank' rel="noreferrer" aria-label="Visit our Facebook profile"><i className="fab fa-facebook"></i></a>
                                <a href="https://x.com/MamasGuidance" target='_blank' rel="noreferrer" aria-label="Visit our Twitter profile"><i className="fab fa-twitter"></i></a>
                                <a href="https://www.youtube.com/channel/UCCAToEWU7aJAVOlTlEX_6XA" target='_blank' rel="noreferrer" aria-label="Visit our Youtube channel"><i className="fab fa-youtube"></i></a>
                                <a href="https://www.instagram.com/mamas.guidance/" target='_blank' rel="noreferrer" aria-label="Visit our Instagram profile"><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="footer-col">
                        <div className="footer-top">
                            <div className="footer-col">
                                <h4>Classes</h4>
                                <div className='row'>
                                    <div className='col'>
                                        <ul>
                                            <li><IonItem routerLink={"/nursery"}>Nursery</IonItem></li>
                                            <li><IonItem routerLink={"/lkg"}>LKG</IonItem></li>
                                            <li><IonItem routerLink={"/ukg"}>UKG</IonItem></li>
                                            <li><IonItem routerLink={"/class-one"}>Class 1</IonItem></li>
                                            <li><IonItem routerLink={"/class-two"}>Class 2</IonItem></li>
                                        </ul>
                                    </div>
                                    <div className='col'>
                                        <ul>
                                            <li><IonItem routerLink={"/class-three"}>Class 3</IonItem></li>
                                            <li><IonItem routerLink={"/class-four"}>Class 4</IonItem></li>
                                            <li><IonItem routerLink={"/class-five"}>Class 5</IonItem></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-col">
                                <h4>Support</h4>
                                <ul>
                                    <li><IonItem routerLink={"/about-us"}>About Us</IonItem></li>
                                    <li><IonItem routerLink={"/contact-us"}>Contact</IonItem></li>
                                    <li><IonItem routerLink={"/privacy-policy"}>Privacy Policy</IonItem></li>
                                    <li><IonItem routerLink={"/faq"}>FAQs</IonItem></li>
                                    <li><IonItem routerLink={"/disclaimer"}>Disclaimer</IonItem></li>
                                </ul>
                            </div>
                        </div>
                        <h4>Stay Updated</h4>
                        <p>Subscribe to get the latest worksheets & Olympiad practice.</p>
                        <form onSubmit={handleSubmit}>
                            <IonInput className='form-control' name="email" type="email" placeholder="Your email" value={formData.email} onIonChange={handleChange} />
                            <button className='mt-2 newStyleButton' type="submit">Subscribe</button>
                        </form>
                        <IonToast
                            isOpen={showToast}
                            message="Subscribed successfully!"
                            duration={2000}
                            onDidDismiss={() => setShowToast(false)}
                        />
                    </div>
                </div>
            </footer>

            <div className="footer-bottom">
                <p>© <strong>2025</strong> Mama’s Guidance. All rights reserved.</p>
                <p>Trusted by thousands of parents and educators for joyful learning.</p>
            </div>
        </>
    );
};

export default Footer;